import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const createProgramDraft = () => {
  const response = instance({
    method: "post",
    url: `/work/api/constructor/program`
  });
  return response;
};

export const updateProgram = (id, data) => {
  const response = instance({
    method: "put",
    url: `/work/api/program/${id}`,
    data
  });
  return response;
};

export const getBlocks = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/program/${id}/block`
  });
  return response;
}

export const getModules = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/program/${id}/module`
  });
  return response;
}

export const getModulesByBlock = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/program/${id}/module?scope=block`
  });
  return response;
}

export const addBlock = (id, main) => {
  const data = {
    main: main
  };

  const response = instance({
    method: "post",
    url: `/work/api/program/${id}/block`,
    data
  });
  return response;
}

export const updateBlock = (id, blockId, main) => {
  const data = {
    main: main
  };

  const response = instance({
    method: "put",
    url: `/work/api/program/${id}/block/${blockId}`,
    data
  });
  return response;
};

export const deleteBlock = (id, blockId) => {
  const response = instance({
    method: "delete",
    url: `/work/api/program/${id}/block/${blockId}`,
  });
  return response;
}

export const changeExpertiseStatus = (id, comment, methodType) => {
  const data = {
    type: methodType,
    id: id,
    comment: comment
  }
  const response = instance ({
    method: "post",
    url: `/work/api/program/rpc`,
    data
  });
  return response;
}

export const getProgramAuthors = id => {
  const response = instance({
    method: "get",
    url: `/work/api/program/${id}/authoring`
  });
  return response;
};

export const editAuthors = data => {
  const response = instance({
    method: "post",
    url: `/work/api/program/rpc`,
    data
  });
  return response;
};

export const includeModule = (programId, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/program/${programId}/module`,
    data
  });
  return response;
}

export const excludeModule = (programId, moduleId) => {
  const response = instance({
    method: "delete",
    url: `/work/api/program/${programId}/module/${moduleId}`
  });
  return response;
}

export default {
  createProgramDraft,
  updateProgram,
  getBlocks,
  getModules,
  getModulesByBlock,
  includeModule,
  excludeModule,
  addBlock,
  updateBlock,
  deleteBlock,
  changeExpertiseStatus,
  getProgramAuthors,
  editAuthors
}
